<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑团长' : '新增团长'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 团长名称 -->
      <a-form-item
        label="团长名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.name" placeholder="请输入" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick, watch } from 'vue'
import { message } from 'ant-design-vue'
import { leaderSave, agencySearch as fetchAgencySearch } from '@/api/agency'
import Loading from '@/components/Loading'

// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(null)
// 机构ID（从父组件传入）
let providerId = ref(null)
// 表单数据
let formState = reactive({
  // 团长名称
  name: undefined,
  // 机构ID
  provider_id: undefined
})
// 加载
let isLoading = ref(false)

function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 同步选择到提交用的 providerId
watch(() => formState.provider_id, (val) => {
  providerId.value = val
})

// 打开抽屉
function showDrawer (params, supplierid) {
  // 展开
  visible.value = true
  // id
  id.value = params?.id
  // 机构ID（优先父组件传入）
  providerId.value = supplierid
  formState.provider_id = supplierid
  // 赋值
  nextTick(() => {
    if (params?.id) {
      formState.name = params.name
    } else {
      formState.name = undefined
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    leaderSave({
      id: id.value,
      provider_id: providerId.value,
      name: formState.name
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        onClose()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>

</style>